/**
 * Dynamic class for holding the local properties of a particle, used for processing the static properties
 * of particles in the particle animation set before beginning upload to the GPU.
 */
var ParticleProperties = /** @class */ (function () {
    function ParticleProperties() {
    }
    return ParticleProperties;
}());
export { ParticleProperties };
